import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { ChatMessage } from "./ChatMessage";

export const ChatSession = ({chatSession}) =>{

    const chatContainerRef= useRef(null)
    const [chatContainerFontSize, setChatContainerFontSize] = useState(16)
    const bottomRef = useRef(null);

    //scroll to bottom of chat session
    useLayoutEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [chatSession]);


  // ctrl + scroll to change font size in chat

    useEffect(() => {
        const container = chatContainerRef.current;
    
        const handleWheelZoom = (e) => {
          if (e.ctrlKey) {
            e.preventDefault();
    
            setChatContainerFontSize((prev) => {
              const newSize = Math.min(Math.max(prev + (e.deltaY < 0 ? 1 : -1), 12), 28);
              return newSize;
            });
          }
        };
    
        if (container) {
          container.addEventListener('wheel', handleWheelZoom, { passive: false });
        }
    
        return () => {
          if (container) {
            container.removeEventListener('wheel', handleWheelZoom);
          }
        };
      }, []);
   
        return (
            <div ref={chatContainerRef} className="chat-session-container" style={{ fontSize: `${chatContainerFontSize}px` }}>
                {
                    chatSession.map((message) => {
                        const relevantPart = message.parts.find(part => part.text);
                        if(!relevantPart || relevantPart?.text?.startsWith('FunctionResponse:') || relevantPart?.text?.startsWith('AdditionalContext:')) return null
                        return <ChatMessage message={message}/>
                    })
                }
                <div ref={bottomRef}/>
            </ div>
        )
    }